module.exports = __webpack_public_path__ + "static/media/10 - The Floaters - Float On.cee43826.mp3";